import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';

export const CustomKioskUIWarningDialog = ({ open, onClose, onConfirm, handleInputChange }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Warning</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to edit the HTML of the Kiosk? This should be done with care, as you can break the Kiosk if you make an error in your HTML code. However, you can always revert back to the original should there be an issue.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={() => {
                    handleInputChange({ target: { name: "SettingCustomKioskUI", type: "checkbox", checked: true } });
                    onClose();
                }}>Proceed</Button>
            </DialogActions>
        </Dialog>
    );
};

export const RevertWarningDialog = ({ open, onClose, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Warning</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to revert to the server original? 
                    You will lose any customisations that you have made.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm}>OK</Button>
            </DialogActions>
        </Dialog>
    );
};

